import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const Tooltip = (props) => {
  // check full list of props at https://github.com/atomiks/tippyjs-react#-props
  return <Tippy {...props} />;
};

export default Tooltip;
